// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5V4.5C16.1421 4.5 19.5 7.85786 19.5 12Z"}}]};

const ContrastFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'contrast-filled',
    ref,
    icon: element,
  },
));

ContrastFilledIcon.displayName = 'ContrastFilledIcon';

export default ContrastFilledIcon;
